export enum EMAIL_TEMPLATE_COLUMN {
  Name = "name",
  Subject = "subject",
  Type = "type",
  CreatedDate = "createdDate",
  Actions = "actions"
}
